import moment from 'moment';
export function truncate(str, n) {
    if (!str) return;
    return str.length > n ? str.substr(0, n - 1) + '...' : str;
}
export async function isObjectEmpty(obj) {
    return Object.entries(obj).length === 0 && obj.constructor === Object;
}

export function isFilterEmpty(obj) {
    if (!obj) return true;
    let objectEmpty = isObjectEmpty(obj);
    if (objectEmpty) return true;
    else {
        let isEmpty = true;
        for (let [item, value] of Object.entries(obj)) {
            if (value) {
                if (Array.isArray(value) && !value.length) continue;
                return (isEmpty = false);
            }
        }
        return isEmpty;
    }
}

export function cloneObject(obj) {
    return JSON.parse(JSON.stringify(obj));
}

export const deepCopy = inObject => {
    let outObject, value, key;

    if (typeof inObject !== 'object' || inObject === null) {
        return inObject; // Return the value if inObject is not an object
    }

    // Create an array or object to hold the values
    outObject = Array.isArray(inObject) ? [] : {};

    for (key in inObject) {
        value = inObject[key];

        // Recursively (deep) copy for nested objects, including arrays
        outObject[key] = deepCopy(value);
    }

    return outObject;
};

export function wait(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

export function formatPagination({ itemsPerPage, page }) {
    return {
        itemsPerPage,
        currentItem: itemsPerPage * (page - 1)
    };
}

export function formatDate(date, format = 'DD.MM.YYYY') {
    if (!date) {
        return;
    }
    return moment(String(date)).format(format);
}

/**
 * Resolves object's inner properties by given path
 */
export function resolveByPath(path, obj) {
    return path.split('.').reduce((prev, curr) => prev && prev[curr], obj);
}

/**
 * Converts given string to arraybuffer
 */
export function s2ab(str) {
    const buffer = new ArrayBuffer(str.length);
    const view = new Uint8Array(buffer);
    for (var i = 0; i != str.length; ++i) view[i] = str.charCodeAt(i) & 0xff;
    return buffer;
}

export function debounce(func, time) {
    let timer;
    return function(args) {
        clearTimeout(timer);
        timer = setTimeout(() => {
            func(args);
        }, time);
    };
}

export const maskaOptions = vueComponent => {
    return {
        mask: '+7 (###) ### ## ##',
        eager: true,
        onMaska: val => {
            vueComponent.phone = { ...val, unmasked: '7' + val.unmasked };
        }
    };
};

export const getToday = () => {
    const today = moment();
    return today.format('DD-MM-YYYY');
};

export function base64ToObjectURL(base64String, mimeType) {
    // Remove the data URL prefix if it exists
    const base64WithoutPrefix = base64String.replace(/^data:[^;]+;base64,/, '');

    // Convert the Base64 string to a Uint8Array
    const binaryData = Uint8Array.from(atob(base64WithoutPrefix), char => char.charCodeAt(0));

    // Create a Blob from the binary data
    const blob = new Blob([binaryData], { type: mimeType });

    // Create an object URL from the Blob
    return URL.createObjectURL(blob);
}
